import { atom } from 'recoil';
import { FilterDef } from '../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "invoices-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'invoices-state-active-filters',
    default: []
});

export const  STATE_INSIGHT_MODAL = atom <any>({
    key: 'invoices-state-insight-modal',
    default : undefined
});

export const STATE_CUSTOMER_IN_URL = atom<any>({
    key: "invoices-state-customer-updating",
    default: undefined,
  });
 